
import { Component, OnInit } from '@angular/core';
import { MenuItem } from '../menu-item'; 
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {
 
 
  loading = false;
  submitted = false;
  returnUrl: string | undefined;
  isMobile:boolean| undefined;
  showMobileMenu:boolean = false;
  showsuccess:boolean| undefined;
  showerror:boolean| undefined;
  showDialog:boolean| undefined;
  showLogin:boolean| undefined;
  showRegister:boolean| undefined;
  showForgotPassword: boolean| undefined;
  ForgotPasswordEmail: string| undefined;
  success = '';
  error = '';
 
  constructor() { }

  ngOnInit(): void {
    this.checkisMobile();
  }

  ShowMobileMenu()
  {
    this.showMobileMenu = true;

  }
  menuItems: MenuItem[] = [
    {
      label: 'Home',
      routerlink: '/home',
      icon: 'home',  hasPNG: false,
      loggedInRequired: true,
      adminRequired: false,
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:true
    },
    {
      label: 'My Projects',
      routerlink: '/projects',
      icon: 'local_shipping', hasPNG: false,
      loggedInRequired: true,
      adminRequired: true,
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: false,
      showOnBottomNav:false
    },
    {
      label: 'My Bids',
      routerlink: '/project-bids',
      icon: 'local_shipping', hasPNG: false,
      loggedInRequired: true,
      adminRequired: true,
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: false,
      showOnBottomNav:false
    },
    {
      label: 'Distributors',
      routerlink: '/distributor-grid',
      icon: 'local_shipping', hasPNG: false,
      loggedInRequired: true,
      adminRequired: true,
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: false,
      showOnBottomNav:false
    },
    {
      label: 'Contractors',
      routerlink: '/contractors', hasPNG: false,
      icon: 'people',
      loggedInRequired: false,
      adminRequired: true,
      showOnMobile: true,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:false
    },
    {
      label: 'Materials',
      routerlink: '/materials', hasPNG: false,
      icon: 'foundation',
      loggedInRequired: false,
      adminRequired: true,
      showOnMobile: true,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:false
    },
    {
      label: 'Equipment',
      routerlink: '/equipment', hasPNG: false,
      icon: 'construction',
      loggedInRequired: false,
      adminRequired: true,
      showOnMobile: true,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:false
    },{
      label: 'Manufacturers',
      routerlink: '/manufacturers', hasPNG: false,
      icon: 'account_circle',
      loggedInRequired: false,
      adminRequired: true,
      showOnMobile: true,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:false
    },
    // {
    //   label: 'Events',
    //   routerlink: '/Events',
    //   icon: 'line_style', hasPNG: false,
    //   loggedInRequired: true,
    //   adminRequired: true,
    //   showOnMobile: false,
    //   showOnTablet: true,
    //   showOnDesktop: false,
    //   showOnBottomNav:false
    // },
  
    // {
    //   label: 'Paypal',
    //   routerlink: '/paypal',
    //   icon: 'rss_feed',
    //   loggedInRequired: false,
    //   adminRequired: true,
    //   showOnMobile: true,
    //   showOnTablet: true,
    //   showOnDesktop: true
    // },
    // {
    //   label: 'My Account',
    //   routerlink: '/bankaccount',
    //   icon: 'account_circle', hasPNG: false,
    //   loggedInRequired: true,
    //   adminRequired: false,
    //   showOnMobile: true,
    //   showOnTablet: true,
    //   showOnDesktop: true,
    //   showOnBottomNav:true
    // },
    {
      label: 'Admin',
      routerlink: '/admin', hasPNG: false,
      icon: 'account_circle',
      loggedInRequired: false,
      adminRequired: true,
      showOnMobile: true,
      showOnTablet: true,
      showOnDesktop: true,
      showOnBottomNav:false
    },
  ];
 

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
    }
      else
    {this.isMobile = false;}
    
    
  }
}
